export default "__VITE_ASSET__DB5ghyi6__"